import { useMutation, useQueryClient } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';
import type { InvokeRequest, InvokeResultDto } from '../types/integrationHub';

/**
 * POST /api/eraf/integration-hub/endpoints/{id}/invoke — 연동 호출 (INTEGRATION_INVOKE)
 * 호출 성공 시 call-logs 캐시 무효화
 */
export function useInvoke() {
  const queryClient = useQueryClient();
  return useMutation<InvokeResultDto, { code: string; message: string }, { id: number; req: InvokeRequest }>({
    mutationFn: ({ id, req }) => integrationHubApi.invokeEndpoint(id, req),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['integration-hub', 'call-logs'] });
    },
  });
}
